import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import { Helpers } from '../../../core/src/helpers';
import ValueProp from './value-prop';

const EMPTY_OBJ = {};

const mapStateToProps = (state, ownProps) => {
	const { pdp, slugInfo, router } = state;
	const { pathname } = router && router.location;
	const { templateKey } = slugInfo;
	const urlParts = Helpers.parseUrl(pathname, false, process.env.BASENAME);
	const isPDP = urlParts.directory === 'pdp' && urlParts.slug === pdp.slug;
	const isV2PDP = templateKey === 'pdp-v2';
	const isHomepage = templateKey === 'home';
	let valueProp;
	//for now check pdp seperately. Eventually it should the page component and store data in slugInfo
	if (isPDP && !isV2PDP) {
		const { pdpConfig = EMPTY_OBJ } = pdp;
		const { globalValueProp = EMPTY_OBJ } = pdpConfig;
		valueProp = globalValueProp && globalValueProp.valueProp;
	} else if (slugInfo.vanityUrl === `${urlParts.directory}/${urlParts.slug}` || isHomepage) {
		const { components = EMPTY_OBJ } = slugInfo;
		const { globalValueProp = EMPTY_OBJ } = components;
		valueProp = globalValueProp && globalValueProp.valueProp;
	}

	return {
		/**
		 * temp, later would need to switch to better targeting
		 */
		isV2: isV2PDP || isHomepage,
		pathname,
		valueProp
	};
}

const mapDispatchToProps = dispatch => {
	return {
		pushHistory: (pathname, queryString) => {
			dispatch(push({
				pathname: pathname,
				search: queryString
			}));
		}
	}
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ValueProp);